import "./Summary.scss";
import pwImageCreditCard from "../../assets/images/3-cards-small.png";
import pwImageCoin from "../../assets/images/BubbleCoin.webp";
import pwImageDiamond from "../../assets/images/diamond.png";
import pwImagePackage from "../../assets/images/BubblePackage.webp";
import locale from "../../assets/locale.json";
import { useParseText } from "../../utils/useParseText";
import InfoBox from "../InfoBox/InfoBox";
import FeatureBoxList from "../FeatureBoxList/FeatureBoxList";
import {useAuthContext} from "../../utils/AuthContext";


function Summary() {
  const { parseText } = useParseText();
  const { responseError } = useAuthContext();

  const features = [
    {
      image: pwImageCreditCard,
      alt: "Nuove dinamiche di gioco",
      text: "Oltre alla Postepay Evolution ottieni possibilità anche con le carte Postepay Debit e Postepay Digital"
    },
    {
      image: pwImageDiamond,
      alt: "Esperienza coinvolgente",
      text: "Con i Postepay Days aumenti le possibilità per provare a vincere nuovi premi"
    },
    {
      image: pwImagePackage,
      alt: "Possibilità di vincita",
      text: "Nuovi fantastici premi in palio con più di 15.000 Buoni Regalo Amazon.it* e un viaggio da sogno in Lapponia"
    }
  ];

  return (
    <section className="pw-container pw-container-summary">

      <div className="container-info">
        { responseError === 405 ? (
          <>
            <h2
            className="title-two-regular pw-summary-title" >POSTEPAY PAY&WIN si rinnova con grandi novità!</h2>
            <FeatureBoxList features={features} className="old-user-message list-summary" />
          </>
        ) : (
          <>
        
        <h2
          className="title-two-regular pw-summary-title"
          dangerouslySetInnerHTML={parseText(locale.summary.title)}
        />
        <p
          className="title-two-regular pw-summary-subtitle"
          dangerouslySetInnerHTML={parseText(locale.summary.subtitle)}
        />

          <div className="info-box-wrapper">
            <div className="pw-info-wrapper-center row">
            <InfoBox
              className="col-4"
              image={pwImageCreditCard}
              alt={locale.summary.info_box.pw_creditCard.alt}
              text={
                <p
                  className="paragraph-xs pw-info-box-text"
                  dangerouslySetInnerHTML={parseText(locale.summary.info_box.pw_creditCard.text)}
                />
              }
            />
            <InfoBox
              className="col-4"
              image={pwImageCoin}
              alt={locale.summary.info_box.pw_coin.alt}
              text={
                <p
                  className="paragraph-xs pw-info-box-text"
                  dangerouslySetInnerHTML={parseText(locale.summary.info_box.pw_coin.text)}
                />
              }
            />
            <InfoBox
              className="col-4"
              image={pwImagePackage}
              alt={locale.summary.info_box.pw_package.alt}
              text={
                <p
                  className="paragraph-xs pw-info-box-text"
                  dangerouslySetInnerHTML={parseText(locale.summary.info_box.pw_package.text)}
                />
              }
            />
            </div>
          </div>
          </>
        )}
      </div>
    </section>
  );
}

export default Summary;